import { ComponentType, useState } from 'react';
import PageHeading from 'components/heading';
import { Tabs, TabsList, TabsTrigger, TabsContent } from 'components/ui/tabs';
import { Icon, IconName } from 'components/ui/icon';
import LocationConfiguration from '../locationConfig';
import ExternalConfiguration from './externalConfig';
import StaticQR from './staticQR';
import {
  SystemConfigurationTab,
  SystemConfigurationTabLabels,
} from 'types/settings/systemConfig';
import HostedPaymentConfig from './loyaltyConfig';

const TABS: {
  value: SystemConfigurationTab;
  label: string;
  icon: IconName;
  Component: ComponentType;
}[] = [
  {
    value: SystemConfigurationTab.POS_LOCATION_CONFIGURATIONS,
    label: SystemConfigurationTabLabels[SystemConfigurationTab.POS_LOCATION_CONFIGURATIONS],
    icon: 'store',
    Component: LocationConfiguration,
  },
  {
    value: SystemConfigurationTab.EXTERNAL_CONFIGURATIONS,
    label: SystemConfigurationTabLabels[SystemConfigurationTab.EXTERNAL_CONFIGURATIONS],
    icon: 'link',
    Component: ExternalConfiguration,
  },
  {
    value: SystemConfigurationTab.STATIC_QR,
    label: SystemConfigurationTabLabels[SystemConfigurationTab.STATIC_QR],
    icon: 'qr-code',
    Component: StaticQR,
  },
  {
    value: SystemConfigurationTab.HOSTED_PAYMENT,
    label: SystemConfigurationTabLabels[SystemConfigurationTab.HOSTED_PAYMENT],
    icon: 'gift',
    Component: HostedPaymentConfig,
  },
];

const SystemConfig = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState(
    SystemConfigurationTab.POS_LOCATION_CONFIGURATIONS
  );

  const toggleTab = (tabValue: string) => {
    setActiveTab(tabValue as SystemConfigurationTab);
  };

  return (
    <div className="rounded-lg">
      <PageHeading heading="System configurations" overrideContainerClass />

      <Tabs value={activeTab} onValueChange={toggleTab} className="w-full">
        <div className="border-b border-gray-blue-10">
          <TabsList className="h-auto p-0 bg-transparent rounded-none border-0 w-full justify-start">
            {TABS.map((tab) => (
              <TabsTrigger
                key={tab.value}
                value={tab.value}
                className="first:ml-0 mx-3 px-0 w-fit py-3 rounded-none border-b-2 border-transparent data-[state=active]:border-treez-green data-[state=active]:text-gray-blue-80 data-[state=active]:bg-transparent text-gray-blue-60 hover:text-gray-blue-80 hover:border-gray-blue-20 data-[state=active]:shadow-none inline-flex items-center gap-2"
              >
                <Icon name={tab.icon} size={16} aria-hidden="true" />
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>

        <div className="py-4">
          {TABS.map(({ value, Component }) => (
            <TabsContent key={value} value={value} className="mt-0">
              <Component />
            </TabsContent>
          ))}
        </div>
      </Tabs>
    </div>
  );
};

export default SystemConfig;
